// @ts-nocheck
import styles from './notifications-modal.module.scss';

import {
  Modal,
  H1,
  H2,
  Button,
  GKSelect,
  GKInput,
  BtnLevel,
  Icon,
  IconEnum,
} from '../..';

import { DisplayDateTime } from '@greenkub-fronts/shared/utils';
import {
  Notification,
  NotificationType,
} from '@greenkub-fronts/shared/interface';

export interface NotificationsModalProps {
  isOpen: boolean;
  onChangeIsOpen: Function;
  notifications: Notification[];
  mode: string;
  setMode: Function;
  notificationType: NotificationType | null;
  notificationTitle: string;
  setNotificationTitle: Function;
  setNotificationContent: Function;
  notificationContent: string;
  expenseCard: Function;
  openUpateNotification: Function;
  notificationTypes: NotificationType[];
  onTypeChange: Function;
  deleteNotificationHandler: Function;
  createNotificationHandler: Function;
  updateNotificationHandler: Function;
}

export function NotificationsModal(props: NotificationsModalProps) {
  const {
    isOpen,
    onChangeIsOpen,
    mode,
    setMode,
    notifications,
    notificationType,
    notificationTitle,
    setNotificationTitle,
    setNotificationContent,
    notificationContent,
    expenseCard,
    openUpateNotification,
    notificationTypes = [],
    onTypeChange,
    deleteNotificationHandler,
    createNotificationHandler,
    updateNotificationHandler,
  } = props;

  return (
    <Modal
      className={styles['NotificationsModal']}
      isOpened={isOpen}
      onCloseModal={() => {
        onChangeIsOpen(false);
      }}
      hasCloseBtn={true}
    >
      <div className={styles['NotificationsModal-content']}>
        <H1 value="Push de notification client" />

        {mode === 'read' && (
          <div className={styles['NotificationsModal-content-read']}>
            <div>
              {notifications.length === 0 ? (
                <p>Aucune notification</p>
              ) : (
                notifications.map((notif, index) => (
                  <div
                    className={styles['NotificationsModal-item']}
                    key={index}
                    onClick={() => expenseCard(notif.id)}
                  >
                    <div className={styles['NotificationsModal-item-state']}>
                      {notif.seenAt ? 'Vu' : 'Non Vu'}
                    </div>

                    <H2 value={notif.title} />

                    <p>{notif.notificationType?.name}</p>

                    <p>{notif.content}</p>

                    <div className={styles['action-btns']}>
                      <Button
                        level={BtnLevel.SECONDARY}
                        onClick={() => deleteNotificationHandler(notif.id)}
                        IconeLeft={IconEnum.DELETE}
                        label="Supprimer"
                      />
                      <Button
                        onClick={() => openUpateNotification(notif.id)}
                        IconeLeft={IconEnum.CREATE}
                        label="Editer"
                      />
                    </div>

                    <p>
                      Créé le {DisplayDateTime(notif.createdAt)} par{' '}
                      {notif.createdBy.firstName}
                    </p>
                  </div>
                ))
              )}
            </div>

            <Button
              onClick={() => setMode('create')}
              label="Nouvelle notification"
            />
          </div>
        )}

        {['create', 'update'].includes(mode) && (
          <div>
            <H1 value="Sélectionner un type de notification" />

            {mode === 'create' && <h2>Création d'une nouvelle notification</h2>}
            {mode === 'update' && (
              <h2>Mise à jour d'une notification existante</h2>
            )}

            <GKSelect
              name="Notification"
              placeholder="Types de notification"
              options={notificationTypes.map((type) => {
                return {
                  value: type.id + '',
                  label: type.name,
                };
              })}
              defaultValue={notificationType && notificationType.id}
              customOnChange={(value: any) => {
                onTypeChange(value);
              }}
            />

            {notificationType && <p>{notificationType.description}</p>}

            <H1 value="Titre de la notification" />

            <GKInput
              name="title"
              className="GKInput"
              type="text"
              defaultValue={notificationTitle}
              onChangeValue={(value: string) => setNotificationTitle(value)}
            />

            <H1 value="Message" />

            <textarea
              maxLength={255}
              style={{ height: '150px' }}
              onChange={(event) => setNotificationContent(event.target.value)}
              defaultValue={notificationContent}
            />

            {notificationContent && (
              <small>
                {255 - notificationContent.length} caractères restants
              </small>
            )}

            <div className={styles['action-btns']}>
              <Button onClick={() => setMode('read')} label="Retour" />
              {mode === 'create' && (
                <Button
                  onClick={() => createNotificationHandler()}
                  label="Créer"
                />
              )}

              {mode === 'update' && (
                <Button
                  onClick={() => updateNotificationHandler()}
                  label="Mettre à jour"
                />
              )}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default NotificationsModal;
